<div style="width: 100%; height: 60px;">
    <div style="float:right; width: 180px; cursor: pointer;" (click)="onEmail()">
        <img src="../../assets/email.png" alt="Share with email" style="width: 48px; height: auto; vertical-align: middle;">
        <span style="vertical-align: middle;font-weight: bold;margin-left:10px; font-size: 22px;">Email</span>
    </div>

    <div style="float:right; width: 180px; cursor: pointer;" (click)="onDownload()">
        <img src="../../assets/down-arrow.png" alt="Share with email" style="width: 38px; height: auto; vertical-align: middle;">
        <span style="vertical-align: middle;font-weight: bold;margin-left:10px; font-size: 22px;">Download</span>
    </div>
    <!--
    <div class="searchbar" >
        <input style="width: 70%; min-width: 200px; line-height: 30px;" class="appInput" (input)="onSearchTextChanged()" type="text"  [(ngModel)]="this.searchtext" placeholder="Enter date, title or category name to search"/>
        <br>
        <a style="line-height: 40px;" href="https://chrome.google.com/webstore/detail/google-input-tools/mclkkofklkfljcocdinagocijmpgbhab?hl=en" target="_blank"> Change input language</a> 
   </div>
    -->


</div>


<div class="clearfix" style="background-color: black; color: white;">
    <ul >
        <li>Date</li>
        <li>Title</li>
        <li>Category</li>
        <li>View Details</li>
    </ul>
</div>


<div *ngFor="let doc of docs" class="clearfix" style="background-color: #bbb;">
    <li>{{doc.documentdate * 1000 | date:'dd/MM/yyyy'}}</li>
    <li>{{doc.title}} 
        <img  (click)="onViewPropertyDocumentDetails(doc)" *ngIf="doc.isnotarized" src="../../assets/seal.png" alt="Share with email" style="width: 24px; height: auto; cursor: pointer; vertical-align: middle;">
    </li>
    <li><a href="#" style="color:black" (click)="onViewCategory(doc.cat)"> {{doc.cat.DocumentCategoryName}}</a></li>
    <li>
        <input type="button" value="View Document" class="appButton" style="float: right; margin: 5px; " (click)="onViewDocument(doc)">
    </li>
</div>

<div>
    <div class="clearfix" style="background-color: black; color: white;">
        <ul >
            <li>Notes</li>
        </ul>
    </div>
    <div class="clearfix" style="background-color: #bbb;">
        <div style="padding:25px;">
        {{documentNotes}}
        </div>
    </div>
</div>